import FormFieldHelper from "../FormFieldHelper";
import FormFieldComponent from "./_FormFieldComponent";

export default class MultipleChoiceFormFieldComponent extends FormFieldComponent
{
    field;
    fieldAlias;
    items;
    constructor(el) {
        super(el);
        
        this.field = this.el.querySelector('[data-umb-field-alias]');
        this.items = this.field.querySelectorAll('[data-umb-field-item]');
        this.fieldAlias = this.field.dataset.umbFieldAlias;

        const requiredValidator = FormFieldHelper.getRequiredFieldValidator(this.field);
        if (typeof (requiredValidator) !== 'undefined') {
            this.validators.push(requiredValidator);
        }
    }

    getValue() {
        const values = [];

        if (typeof(this.items) === 'undefined' || this.items.length === 0){
            return values;
        }

        for (var i = 0; i < this.items.length; i++) {   
            const item = this.items[i];
            
            if (item.checked) {
                values.push(item.value);
            }
        }

        console.log(values);

        return values;
    }

    getFieldAlias() {
        return this.fieldAlias;
    }
}